import { render, staticRenderFns } from "./over.vue?vue&type=template&id=55cccaaa&scoped=true&"
import script from "./over.vue?vue&type=script&lang=js&"
export * from "./over.vue?vue&type=script&lang=js&"
import style0 from "./over.vue?vue&type=style&index=0&id=55cccaaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cccaaa",
  null
  
)

export default component.exports